export default [
    {
        path: '/login',
        name: 'Log In',
        components: {
            // default: () => import(/* webpackChunkName: "auth" */ '../views/auth/login'),
        },
        meta: {
            guest: true,
            show_in_search: false
        },
    },
    {
        path: '/reset',
        name: 'Reset Password',
        components: {
            // default: () => import(/* webpackChunkName: "auth" */ '../views/auth/reset'),
        },
        meta: {
            guest: true,
            show_in_search: true
        }
    }
];
